import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  spectralis_high_res: null,
  maia_tgz_file: null,
};

export const manMeasurementSlice = createSlice({
  name: 'manMeasurements',
  initialState,
  reducers: {
    addMeasurement: (state, action) => { 
      state[action.payload.name] = action.payload.value
    },
  },
});

export const { addMeasurement } = manMeasurementSlice.actions; 

export default manMeasurementSlice.reducer;
